import { useEffect } from 'react';
import { BackendSubscriptionAction } from '../../../../request/interfaces/backend-subscription';
import EntityBanner from '../../../../shared/components/EntityBanner/EntityBanner';
import { JobsView } from '../JobsView';
import { useQuery } from '../../../../request/hooks/useQuery';
import { PipelineAPI } from '../../../../pipelines/api/PipelineAPI';
import { IntegrationBannerFactory } from '../../../../pipelines/factories/integrationFactory';
import { EntityBannerType } from '../../../../shared/components/EntityBanner/constant';
import styles from './PipelineJobsView.module.scss';
import { Integration } from '../../../../shared/interfaces/integration';

export function PipelineJobsView({ integration }: { integration: Integration }) {
  const { id: integrationId, status: integrationStatus, config: integrationConfig } = integration;
  const { data: banners, fetch: fetchBanners } = useQuery({
    dataSource$: () =>
      PipelineAPI.getPipelineBanners(integrationId).then(res =>
        IntegrationBannerFactory(res.data.banners)
      ),
    subscriptionQueries: [
      {
        event: 'PIPELINE_STATUS_UPDATED',
        ids: [integrationId],
        action: BackendSubscriptionAction.UPDATE
      }
    ]
  });

  useEffect(() => {
    fetchBanners();
  }, []);

  return (
    <div className='w-100'>
      {banners?.length ? (
        <div className='body-container pb-0'>
          {banners.map(item => (
            <EntityBanner
              key={item.title}
              dataId={item.title}
              type={item.type as EntityBannerType}
              title={item.title}
              content={item.content}
              docLink={item.docLink ?? undefined}
              className={styles.banner}
            />
          ))}
        </div>
      ) : null}

      <JobsView
        integrationId={integrationId}
        integrationStatus={integrationStatus}
        integrationConfig={integrationConfig}
      />
    </div>
  );
}
